import request from '@/utils/request'

export function getLatestLesson(params) {
  return request({
    url: '/api/v1/teachers/latestLesson',
    method: 'get',
    params
  })
}
export function getCurrtWeekScheduledCount(params) {
  return request({
    url: '/api/v1/teachers/currtWeekScheduledCount',
    method: 'get',
    params
  })
}
export function getNeedAvailableTimeList(params) {
  return request({
    url: '/api/v2/lesson/vt/getNeedAvailableTimeList',
    method: 'get',
    params
  })
}
export function getlessonsHomePage(params) {
  return request({
    url: '/api/v1/teachers/lessonsHomePage',
    method: 'get',
    params
  })
}
export function saveAvailableTimes(params) {
  return request({
    url: '/api/v1/teachers/saveAvailableTimes',
    method: 'get',
    params
  })
}
export function updateAvailableTimes(params) {
  return request({
    url: '/api/v2/lesson/updateAvailableTimes',
    method: 'post',
    params
  })
}
export function addTempAvailableTime(data) {
  return request({
    url: '/api/v1/teachers/addTempAvailableTime',
    method: 'post',
    data
  })
}
export function addAvailableTimeBatch(params) {
  return request({
    url: '/api/v2/lesson/addAvailableTimeBatch',
    method: 'post',
    params
  })
}
export function cancelTempAvailableTime(params) {
  return request({
    url: '/api/v1/teachers/cancelTempAvailableTime',
    method: 'get',
    params
  })
}
export function getCourseList(params) {
  return request({
    url: '/api/v1/teachers/teacherCourseList',
    method: 'get',
    params
  })
}
export function getOpenCourseList(params) {
  return request({
    url: '/api/v1/teachers/openLessonsList',
    method: 'get',
    params
  })
}
export function getTrialCourseList(params) {
  return request({
    url: '/api/v1/teachers/trialLessonsList',
    method: 'get',
    params
  })
}
export function getCourseLevel(params) {
  return request({
    url: '/api/v1/teachers/courseList',
    method: 'get',
    params
  })
}
export function getUnitList(params) {
  return request({
    url: '/api/v1/teachers/unitList',
    method: 'get',
    params
  })
}
export function getlessonList(params) {
  return request({
    url: '/api/v1/teachers/lessonPlanList',
    method: 'get',
    params
  })
}

export function lessonListByStatus(params) {
  return request({
    url: '/api/v1/teachers/lessonListByStatus',
    method: 'get',
    params
  })
}

export function getDocPages(params) {
  return request({
    url: '/api/v1/lessons/getDocPages',
    method: 'get',
    params
  })
}
export function getSlideNote(params) {
  return request({
    url: '/api/v1/teachers/showSlideNote',
    method: 'get',
    params
  })
}
export function editSlideNote(data) {
  return request({
    url: '/api/v1/teachers/slideNotes',
    method: 'post',
    data
  })
}
export function cearteCourse(data) {
  return request({
    url: '/api/v1/teachers/createTeacherCourse',
    method: 'post',
    data
  })
}
export function cancelCourse(params) {
  return request({
    url: '/api/v1/teachers/cancelTeacherCourse',
    method: 'get',
    params
  })
}
export function findLessonByLessonId(params) {
  return request({
    url: 'api/v1/lessons/findLessonByLessonId',
    method: 'get',
    params
  })
}

export function getDocumentScene(params) {
  return request({
    url: 'api/v1/classRoom/vt/getDocumentScene',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/course.js